// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from 'react';
import { func, bool } from 'prop-types';
import noop from 'lodash/noop';

import ModalManager from 'Containers/ModalManager/ModalManager';
import PromptModalComponent from 'Components/PromptModal/PromptModal';

const PromptModal = props => {
  const {
    modalOpen,
    onCloseModal,
    onConfirm = noop,
    onCancel = noop,
    ...rest
  } = props;

  const [open, setOpen] = useState(modalOpen);
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setOpen(modalOpen);
  }, [modalOpen]);

  const handleOnSubmit = async () => {
    try {
      setErr(null);
      setLoading(true);
      await onConfirm();
      onCloseModal();
      setLoading(false);
    } catch (error) {
      setErr(error.message);
      setLoading(false);
    }
  };

  const handleOnClose = async () => {
    if (!loading) {
      setErr(null);
      setLoading(false);
      onCloseModal();
      setOpen(false);
      await onCancel();
    }
  };

  return (
    <ModalManager open={ open }>
      <PromptModalComponent
        loading={ loading }
        error={ err }
        onCancel={ handleOnClose }
        onConfirm={ handleOnSubmit }
        { ...rest }
      />
    </ModalManager>
  );
};

PromptModal.propTypes = {
  modalOpen: bool,
  onCloseModal: func,
  onConfirm: func,
  onCancel: func
};

PromptModal.displayName = 'PromptModalContainer';

export default PromptModal;
